import { Box } from '@mui/material'
import React from 'react'
import { theme } from '~/lib/theme'

type Props = {
  children: React.ReactNode
  isBackgroundColored?: boolean
}
export const CampaignPostFooter: React.FC<Props> = ({ children, isBackgroundColored = true }) => {
  return (
    <Box bgcolor={isBackgroundColored ? theme.palette.surface.primary : 'transparent'} borderRadius="8px" px={4} py={2}>
      {children}
    </Box>
  )
}
